export default __webpack_public_path__ + "f4c3ae1.png";